import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        console.log('🔍 Login attempt:', { username, passwordLength: password.length });

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, { 
                username, 
                password 
            });

            console.log('📊 Login response:', res.data);

            // Cek apakah response berhasil
            if (res.data.success && res.data.token) {
                const { token, role, user } = res.data;
                
                console.log('✅ Login successful:', { token: token.substring(0, 20) + '...', role, user });
                
                // Simpan data ke localStorage
                localStorage.setItem('token', token);
                localStorage.setItem('role', role);
                localStorage.setItem('user', JSON.stringify(user));
                
                console.log('💾 Data saved to localStorage');
                
                // Redirect berdasarkan role
                if (role === 'admin') {
                    console.log('🚀 Redirecting to admin dashboard');
                    navigate('/dashboard');
                } else if (role === 'anggota') {
                    console.log('🚀 Redirecting to user dashboard');
                    navigate('/dashboard-user');
                } else {
                    console.error('❌ Unknown role:', role);
                    setError('Role pengguna tidak valid: ' + role);
                    // Clear localStorage jika role tidak valid
                    localStorage.removeItem('token');
                    localStorage.removeItem('role');
                    localStorage.removeItem('user');
                }
            } else if (res.data.token) {
                // Handle response format lama (tanpa success field)
                const { token, role } = res.data;
                
                console.log('✅ Login successful (legacy format):', { token: token.substring(0, 20) + '...', role });
                
                // Simpan data ke localStorage
                localStorage.setItem('token', token);
                localStorage.setItem('role', role);
                
                // Redirect berdasarkan role
                if (role === 'admin') {
                    console.log('🚀 Redirecting to admin dashboard');
                    navigate('/dashboard');
                } else if (role === 'anggota') {
                    console.log('🚀 Redirecting to user dashboard');
                    navigate('/dashboard-user');
                } else {
                    console.error('❌ Unknown role:', role);
                    setError('Role pengguna tidak valid: ' + role);
                }
            } else {
                console.error('❌ Invalid response format:', res.data);
                setError(res.data.message || 'Login gagal - response tidak valid');
            }
        } catch (err) {
            console.error('❌ Login error:', err);
            
            if (err.response) {
                console.error('Response data:', err.response.data);
                console.error('Response status:', err.response.status);
                
                if (err.response.data && err.response.data.message) {
                    setError(err.response.data.message);
                } else {
                    setError(`Login gagal (${err.response.status}): ${err.response.statusText}`);
                }
            } else if (err.request) {
                console.error('No response received:', err.request);
                setError('Tidak dapat terhubung ke server. Pastikan server berjalan.');
            } else {
                console.error('Request error:', err.message);
                setError('Terjadi kesalahan: ' + err.message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="section is-flex is-justify-content-center is-align-items-center" style={{ minHeight: '100vh', backgroundImage: "url('/login-bg.png')", backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
            <div className="box" style={{ width: '400px' }}>
                <div className="is-flex is-align-items-center mb-5">
                    <img src="/logoSMPN4.png" alt="Logo SMPN 4" style={{ width: '50px', height: '55px', objectFit: 'cover', marginRight: '15px' }} />
                    <div>
                        <strong className="has-text-black">Perpustakaan SMPN 4 Tilatang Kamang</strong>
                        <p className="is-size-7">Perpustakaan Sekolah</p>
                    </div>
                </div>

                {error && (
                    <div className="notification is-danger is-light mb-4">
                        <button className="delete" onClick={() => setError('')}></button>
                        {error}
                    </div>
                )}

                <form onSubmit={handleLogin}>
                    <div className="field">
                        <div className="control">
                            <input
                                className="input is-rounded has-background-light"
                                type="text"
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                disabled={loading}
                                required
                            />
                        </div>
                    </div>

                    <div className="field">
                        <div className="control">
                            <input
                                className="input is-rounded has-background-light"
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                disabled={loading}
                                required
                            />
                        </div>
                    </div>

                    <div className="field mt-4">
                        <div className="control">
                            <button 
                                type="submit" 
                                className={`button is-fullwidth is-rounded has-background-grey-lighter has-text-grey-dark ${loading ? 'is-loading' : ''}`}
                                disabled={loading}
                            >
                                {loading ? 'Login...' : 'Login'}
                            </button>
                        </div>
                    </div>
                </form>
                
                {/* Debug info - hapus setelah masalah teratasi */}
                <div className="mt-4 is-size-7 has-text-grey">
                    <details>
                        <summary>Debug Info (klik untuk lihat)</summary>
                        <p>Username: {username}</p>
                        <p>Password length: {password.length}</p>
                        <p>Loading: {loading.toString()}</p>
                        <p>Error: {error}</p>
                    </details>
                </div>
            </div>
        </div>
    );
};

export default Login;